import React, { ReactNode, useState, useEffect } from 'react';
import styles from './sort.module.scss';
import cx from 'classnames';

interface ISort {
  placeholder?: string;
  icon?: ReactNode;
  ending?: ReactNode;
  value?: string;
  required?: boolean;
  checked?: boolean;
  onChange: (e: string) => void;
}

const initialOption = {
  name: '',
  key: ''
};

const options = [
  { key: 'up', name: 'Ordonat crescător' },
  { key: 'down', name: 'Ordonat descrescător' }
];

const CSorting = (props: ISort) => {
  const [focused, setFocused] = useState(false);
  const [option, setOption] = useState(initialOption);

  useEffect(() => {
    props.onChange(option.key);
    // eslint-disable-next-line
  }, [option]);

  return (
    <section className={styles.section}>
      <div
        className={cx(styles.button, focused ? styles.focused : null)}
        onClick={() => setFocused(!focused)}
      >
        <p className={styles.label}>
          {option.key.length > 0 ? option.name : 'Sortare după dată'}
        </p>
        {focused && (
          <div className={styles.options}>
            <p
              onClick={() => setOption(initialOption)}
              className={styles.option}
            >
              Resetați sortarea
            </p>
            <p onClick={() => setOption(options[0])} className={styles.option}>
              {options[0].name}
            </p>
            <p onClick={() => setOption(options[1])} className={styles.option}>
              {options[1].name}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default CSorting;
